<p-dialog
  [(visible)]="visible"
  (onHide)="close()"
  [header]="((editingUserId ? 'Edit User' : 'Create User') | translate) + ' (' + ('Individual' | translate) + ')'"
  [modal]="true"
  [style]="{ width: '900px' }"
  [dismissableMask]="true"
  styleClass="user-creation-dialog">
  <div
    *ngIf="isLoading"
    class="loading-spinner">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div [ngStyle]="{ opacity: isLoading ? 0.5 : 1, 'pointer-events': isLoading ? 'none' : 'auto' }">
    <p-tabs
      [(value)]="activeTab"
      styleClass="user-creation-tabs">
      <p-tablist>
        <p-tab
          value="0"
          styleClass="tab-main-info">
          {{ "Basic information" | translate }}
        </p-tab>
        <p-tab
          value="1"
          styleClass="tab-additional-info">
          {{ "Roles" | translate }}
        </p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="user-form">
            <div class="form-columns">
              <div class="form-column-left">
                <div class="form-group">
                  <label class="required">{{ "LOGIN" | translate }}</label>
                  <app-input
                    [required]="true"
                    [(ngModel)]="individualForm.login"
                    (ngModelChange)="touchFormValidation()"
                    [disabled]="editingUserId !== null"
                    placeholder="{{ 'ENTER_LOGIN' | translate }}"
                    [style.cursor]="editingUserId !== null ? 'not-allowed' : 'text'" />
                </div>

                <div class="form-group">
                  <label class="required">{{ "E-mail" | translate }}</label>
                  <app-input
                    [type]="'email'"
                    [required]="true"
                    [(ngModel)]="individualForm.email"
                    (ngModelChange)="touchFormValidation()"
                    placeholder="{{ 'Введите email' | translate }}" />
                </div>

                <div class="form-group">
                  <label>{{ "ПИНФЛ" | translate }}</label>
                  <input
                    type="text"
                    pInputText
                    [ngModel]="individualForm.inn"
                    (input)="onInnChange($event)"
                    placeholder="12345678901234"
                    maxlength="14"
                    style="width: 100%; padding: 10px 12px" />
                  <small
                    *ngIf="individualForm.inn && !isInnValid()"
                    style="color: #e24c4c; margin-top: 4px; font-size: 0.85rem">
                    {{ "PINFL_VALIDATION_ERROR" | translate }}
                  </small>
                </div>

                <div class="form-group">
                  <label [class.required]="!editingUserId">{{ "Введите пароль" | translate }}</label>
                  <div
                    class="password-input form-password-input"
                    style="position: relative">
                    <input
                      [type]="showPassword ? 'text' : 'password'"
                      pInputText
                      [(ngModel)]="individualForm.password"
                      (ngModelChange)="onPasswordChange($event)"
                      name="password"
                      placeholder="{{ 'Введите пароль' | translate }}"
                      style="padding-right: 40px; width: 100%" />
                    <button
                      pButton
                      type="button"
                      class="p-button-text"
                      (click)="showPassword = !showPassword"
                      style="
                        position: absolute;
                        right: 5px;
                        top: 45%;
                        transform: translateY(-50%);
                        padding: 0.25rem;
                        height: auto;
                      "
                      title="{{ showPassword ? 'Скрыть пароль' : ('Показать пароль' | translate) }}">
                      <i
                        [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
                        style="font-size: 1.2rem"></i>
                    </button>
                  </div>
                  <button
                    pButton
                    type="button"
                    class="p-button-text generate-password-btn"
                    (click)="generatePassword()"
                    title="{{ 'Сгенерировать пароль' | translate }}">
                    <img
                      src="assets/icons/main/light/lock-password-line.svg"
                      alt="" />
                    <span>{{ "Сгенерировать пароль" | translate }}</span>
                  </button>
                  <small
                    *ngFor="let error of passwordErrorMessages()"
                    style="color: #e24c4c; margin-top: 4px; font-size: 0.85rem; display: block">
                    {{ error | translate }}
                  </small>
                </div>

                <div class="form-group">
                  <label [class.required]="!editingUserId">{{ "Повторите пароль" | translate }}</label>
                  <div
                    class="password-input form-password-input"
                    style="position: relative">
                    <input
                      [type]="showConfirmPassword ? 'text' : 'password'"
                      pInputText
                      [(ngModel)]="individualForm.confirmPassword"
                      (ngModelChange)="onConfirmPasswordChange($event)"
                      name="confirmPassword"
                      placeholder="{{ 'Повторите пароль' | translate }}"
                      style="padding-right: 40px; width: 100%" />
                    <button
                      pButton
                      type="button"
                      class="p-button-text"
                      (click)="showConfirmPassword = !showConfirmPassword"
                      style="
                        position: absolute;
                        right: 5px;
                        top: 50%;
                        transform: translateY(-50%);
                        padding: 0.25rem;
                        height: auto;
                      "
                      title="{{ showConfirmPassword ? 'Скрыть пароль' : ('Показать пароль' | translate) }}">
                      <i
                        [class]="showConfirmPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
                        style="font-size: 1.2rem"></i>
                    </button>
                  </div>
                  <small
                    *ngIf="showPasswordMismatch()"
                    style="color: #e24c4c; margin-top: 4px; font-size: 0.85rem">
                    {{ "PASSWORDS_DO_NOT_MATCH" | translate }}
                  </small>
                </div>

                <div class="form-group">
                  <label>{{ "Телефон" | translate }}</label>
                  <div class="phone-input-wrapper">
                    <input
                      type="tel"
                      pInputText
                      [(ngModel)]="individualForm.phoneNumber"
                      placeholder="+XXX XX XXX XX XX"
                      style="width: 100%" />
                    <img
                      src="assets/icons/main/light/phone-form-icon.svg"
                      class="phone-icon"
                      alt="Phone" />
                  </div>
                </div>

                <div class="form-options">
                  <div class="option-item">
                    <app-checkbox
                      [(ngModel)]="individualForm.emailConfirmed"
                      class="approved-checkbox"></app-checkbox>
                    <label>{{ "Email подтвержден" | translate }}</label>
                  </div>
                  <div class="option-item">
                    <app-checkbox
                      [(ngModel)]="individualForm.approved"
                      class="approved-checkbox"></app-checkbox>
                    <label>{{ "Одобрен" | translate }}</label>
                  </div>
                  <div class="option-item">
                    <app-checkbox
                      [(ngModel)]="individualForm.isBlocked"
                      class="approved-checkbox"></app-checkbox>
                    <label>{{ "Заблокировать пользователя" | translate }}</label>
                  </div>
                </div>
              </div>

              <div class="form-column-right">
                <div class="form-group">
                  <label class="required">{{ "Фамилия" | translate }}</label>
                  <app-input
                    [(ngModel)]="individualForm.lastName"
                    (ngModelChange)="touchFormValidation()"
                    placeholder="{{ 'Введите фамилию' | translate }}" />
                </div>

                <div class="form-group">
                  <label class="required">{{ "Имя" | translate }}</label>
                  <app-input
                    [(ngModel)]="individualForm.firstName"
                    (ngModelChange)="touchFormValidation()"
                    placeholder="{{ 'Введите имя' | translate }}" />
                </div>

                <div class="form-group">
                  <label>{{ "Отчество" | translate }}</label>
                  <app-input
                    [(ngModel)]="individualForm.secondName"
                    placeholder="{{ 'Введите отчество' | translate }}" />
                </div>

                <div class="form-group">
                  <label class="required">{{ "Организация" | translate }}</label>
                  <msf-select
                    [(model)]="individualForm.organization"
                    (modelChange)="touchFormValidation()"
                    [options]="organizationOptions"
                    optionLabel="shortName"
                    optionValue="id"
                    placeholder="{{ 'Select Organization' | translate}}"
                    translateBy="none" />
                </div>

                <div class="form-group">
                  <label>{{ "Комментарий" | translate }}</label>
                  <app-input
                    [(ngModel)]="individualForm.comment"
                    placeholder="{{ 'Введите комментарий' | translate }}" />
                </div>

                <div class="form-group">
                  <label>{{ "Основание подключения" | translate }}</label>
                  <app-input
                    [(ngModel)]="individualForm.connectionBasis"
                    placeholder="{{ 'Введите основание подключения' | translate }}" />
                </div>

                <div class="form-group user-select-with-action">
                  <label>{{ "Руководитель" | translate }}</label>
                  <div class="select-with-button">
                    <msf-select
                      [(model)]="individualForm.parentId"
                      [options]="parentUserOptions"
                      [placeholder]="'Выберите руководителя'"
                      optionLabel="fullName"
                      optionValue="id"
                      translateBy="none"
                      [style.width]="individualForm.parentId ? 'calc(100% - 45px)' : '100%'" />
                    <button
                      *ngIf="individualForm.parentId"
                      class="user-action-button"
                      title="Открыть профиль пользователя">
                      <i class="pi pi-user"></i>
                    </button>
                  </div>
                </div>

                <div class="form-group user-select-with-action">
                  <label>{{ "Заместитель" | translate }}</label>
                  <div class="select-with-button">
                    <msf-select
                      [(model)]="individualForm.deputyId"
                      [options]="parentUserOptions"
                      [placeholder]="'Выберите заместителя'"
                      optionLabel="fullName"
                      optionValue="id"
                      translateBy="none"
                      [style.width]="individualForm.deputyId ? 'calc(100% - 45px)' : '100%'" />
                    <button
                      *ngIf="individualForm.deputyId"
                      class="user-action-button"
                      title="Открыть профиль пользователя">
                      <i class="pi pi-user"></i>
                    </button>
                  </div>
                </div>

                <div class="form-group form-profession-input">
                  <label>{{ "Должность" | translate }}</label>
                  <app-input
                    [(ngModel)]="individualForm.position"
                    placeholder="{{ 'ENTER_POSITION' | translate }}" />
                </div>
              </div>
            </div>

            <div
              *ngIf="individualForm.isBlocked"
              class="blocking-dates">
              <div class="form-group">
                <app-date-picker
                  [(ngModel)]="individualForm.blockoutStartDate"
                  [label]="'BLOCK_START_DATETIME' | translate"
                  [placeholder]="'SELECT_DATE_TIME' | translate"
                  dateFormat="dd.mm.yy"
                  [showTime]="true"
                  [hourFormat]="'24'"
                  [showClear]="true"></app-date-picker>
              </div>

              <div class="form-group">
                <app-date-picker
                  [(ngModel)]="individualForm.blockoutEndDate"
                  [label]="'BLOCK_END_DATETIME' | translate"
                  [placeholder]="'SELECT_DATE_TIME' | translate"
                  dateFormat="dd.mm.yy"
                  [showTime]="true"
                  [hourFormat]="'24'"
                  [showClear]="true"></app-date-picker>
              </div>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="1">
          <div class="user-form">
            <div class="roles-section">
              <div class="roles-list">
                <div
                  *ngFor="let role of rolesData"
                  class="role-checkbox-item">
                  <app-checkbox [(ngModel)]="individualForm.selectedRoles[role.id]"></app-checkbox>
                  <label
                    [for]="'role-' + role.id"
                    class="role-label">
                    <span class="role-name">{{ role | serverTranslate: "names" }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      [label]="'Отправить пользователю' | translate"
      class="p-button-text send-button"
      [disabled]="isSave"
      icon="{{ isSend ? 'pi pi-spinner pi-spin' : '' }}"
      (click)="onSendLetter.emit()">
      <img
        src="assets/icons/main/light/lead-icon-send.svg"
        alt=""
        style="width: 16px; height: 16px; margin-right: 8px" />
    </button>
    <button
      pButton
      type="button"
      [label]="'Сохранить' | translate"
      class="save-button"
      icon="{{ isSave ? 'pi pi-spinner pi-spin' : '' }}"
      [disabled]="isSave || !isFormValid()"
      (click)="save()"></button>
  </ng-template>
</p-dialog>
